import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { filesize } from 'filesize';

@Pipe({
  name: 'formatStorageSize',
  standalone: true,
})
export class FormatStorageSizePipe implements PipeTransform {
  // services
  private readonly translocoService = inject(TranslocoService);

  formatFileSize(fileSizeInBytes: number | undefined): string {
    if (fileSizeInBytes === undefined) {
      return this.translocoService.translate('general.na');
    }
    const locale = this.translocoService.getActiveLang();
    return filesize(fileSizeInBytes, { locale });
  }

  transform(value: number | undefined): string {
    return this.formatFileSize(value);
  }
}
